var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _vm.items.length === 0
        ? _c("li", [_vm._v("Alles möglich")])
        : _vm._l(_vm.items, function(item) {
            return _c(
              "li",
              {
                key: item.id,
                class: { "has-supplements": _vm.hasSupplements(item) }
              },
              [
                _c(
                  "span",
                  { staticClass: "job-display--box-label" },
                  [
                    _c("Label", {
                      attrs: {
                        characteristic: item.item,
                        "label-type": "application"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasSupplements(item)
                  ? _c(
                      "span",
                      { staticClass: "job-display--box-supplements" },
                      _vm._l(item.supplements, function(supplement) {
                        return _c(
                          "span",
                          { key: supplement.characteristicType.id },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.getSupplementsList(supplement.items)
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }